import { Component, inject, Renderer2, RendererFactory2, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DatabaseConnection } from './shared/services/database-connection';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from './shared/services/toastr-service';
import { AuthService } from './auth/services/auth-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private iconRegistry = inject(MatIconRegistry);
  protected readonly title = signal('sygma-front');
  splashScreen = signal<boolean>(false)
  private _snackBar = inject(MatSnackBar)
  private renderer !: Renderer2
  authService = inject(AuthService)

  constructor(
    private dbConnection : DatabaseConnection,
    private toastr : ToastrService,
    private rendererFactory : RendererFactory2
  ){
    //this.initConnection()
        // Set 'material-symbols-outlined' as the default font class
    this.iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    this.renderer = rendererFactory.createRenderer(null, null)
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  ngAfterViewInit(): void {

      /*if(!this.authService.isAuthentificated()){
        this.splashScreen.update(val => true)
         setTimeout(() =>  this.splashScreen.update(val => false), 2000);
      }*/

      this.splashScreen.update(val => true)
      setTimeout(() =>  this.splashScreen.update(val => false), 3000);

      this.dbConnection.connection.subscribe((res) => {
        if(!res){
            this._snackBar.open('MODE LOCAL - HORS LIGNE', '', {horizontalPosition : 'left', verticalPosition : 'bottom'})
            this.renderer.addClass(document.body, 'offline-grayscale')
        }else{
          this._snackBar.dismiss()
          this.renderer.removeClass(document.body, 'offline-grayscale')
        }
      })
  }

}
